import React from 'react';
import { ScaleIcon } from 'lucide-react';
export function Mechanism() {
  return <section aria-labelledby="mecanismo" className="w-full bg-navy text-white" data-id="element-294" data-mp="1m9ecx6vnsf77">
      <div className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-6 sm:py-16 lg:py-28" data-id="element-295" data-mp="1mbitaoaqv6od">
        <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-296" data-mp="1r6oaxax45z6n">
          <div data-id="element-297" data-mp="1w6izh7tf2coj">
            <ScaleIcon className="h-8 w-8 text-gold sm:h-10 sm:w-10" aria-hidden="true" data-id="element-298" data-mp="1w72jcu2mnb57" />
            <h2 id="mecanismo" className="mt-4 font-display text-[1.7rem] font-bold leading-tight sm:mt-6 sm:text-3xl lg:text-[2.75rem]" data-id="element-299" data-mp="ylocjvnb0xyu">
              El Protocolo de <span className="text-gold" data-id="element-300" data-mp="18gosh6vs3ic7">Disputa 609</span>
            </h2>
          </div>

          <div className="space-y-4 text-[1.02rem] leading-relaxed text-white/75 sm:space-y-6 sm:text-lg" data-id="element-301" data-mp="1d9rjp8d32fp8">
            <p data-id="element-302" data-mp="ft2m5qv61zln">
              Es un método basado en la Ley Federal (FCRA) que obliga a los burós a borrar cualquier
              información que no puedan validar con documentos originales firmados por ti.
            </p>
            <p className="font-display text-xl font-semibold leading-snug text-white sm:text-2xl" data-id="element-303" data-mp="pegg4ix3a5qq">
              No pedimos por favor; exigimos bajo la ley.
            </p>
            <p data-id="element-304" data-mp="fl9dv6xnb5uv">
              Si ellos no tienen el papel físico en 30 días, la mancha desaparece de tu historial
              para siempre.
            </p>
          </div>
        </div>
      </div>
    </section>;
}